/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';
import qs from "qs";

export default {
	list(params) {
		return Ajax.get("/employeeSalary", params)
	},
	generateSalary(params) {
		return Ajax.post("/employeeSalary/generate", qs.stringify(params),{'Content-Type':"application/x-www-form-urlencoded"})
	},

	saveSalary(params = {}) {
		return Ajax.post(`/employeeSalary`, params)
	},
	updateSalary(params) {
		return Ajax.put(`/employeeSalary`, params)
	},
	batchDelete(data,date) {
		return Ajax.post(`/employeeSalary/batchDelete?entryDate=`+date, data)
	},




	saveSalaryFields(params = {}) {
		return Ajax.post(`/salaryField`, params)
	},

	listSalaryFields(params = {}) {
		return Ajax.get(`/salaryField`, params)
	},

	salaryFieldUsedCheck(params = {}) {
		return Ajax.get(`/salaryField/usedCheck`, params)
	},

	salaryFieldDelete(id) {//jxd删除
		return Ajax.delete(`/salaryField/${id}`)
	},


	saveSalaryTemplate(params = {}) {
		return Ajax.post(`/salary/template`, params)
	},
	deleteSalaryTemplate(id) {
		return Ajax.delete(`/salary/template/`+id)
	},
	salaryTemplateList(params = {}) {
		return Ajax.get(`/salary/template`, params)
	},
	salaryTemplateAmountList(params = {}) {
		return Ajax.get(`/salary/template/amountList`, params)
	},
}
